export var commonFontsTokens = {
  'font-size-xsmall': '10px',
  'font-size-small': '12px',
  'font-size-base': '14px',
  'font-size-medium': '16px',
  'font-size-large': '18px',
  'font-size-xlarge': '24px',
  'font-size-xxlarge': '36px',
  'font-height-xsmall': '14px',
  'font-height-small': '16px',
  'font-height-base': '20px',
  'font-height-medium': '24px',
  'font-height-large': '28px',
  'font-height-xlarge': '36px',
  'font-height-xxlarge': '50px',
  'font-weight-bold': 700,
  'font-weight-semiBold': 600,
  'font-weight-regular': 400
};